import React from 'react';

import './viewBody.scss';
import './layout.scss';
import 'selfly-ui-core/dist/scss/index.scss';
export default function GlobalLoadingView(props) {
    return (
        <div className="main-view">
            <p style={{margin:'1rem'}}>{'Loading ...'}</p>
        </div>
    );
}
